import React from 'react';
import { Divider } from 'wix-ui-tpa/cssVars';
import { classes, st } from './dividers.st.css';
export const HorizontalDivider = ({ className, type = 'default', }) => React.createElement(Divider, { className: st(classes.root, { type }, className) });
export const BulletDivider = ({ className }) => (React.createElement("div", { className: st(classes.bulletDivider, className) }, "\u2022"));
//# sourceMappingURL=dividers.js.map